import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-empty-content',
    templateUrl: './empty-content.component.html',
    styleUrls: ['./empty-content.component.scss'],
})
export class EmptyContentComponent {
    @Input()
    infoText: string = '';

    constructor() {}
}
